import React from "react"
import * as S from "./Section.styles"

export default function Section({ children }) {
  return <S.Section>{children}</S.Section>
}
